module.exports = __webpack_public_path__ + "static/planetid-hp-artwork-b25d00a6d8d361cfa00ed3157074dc6f.png";